module.exports = __webpack_public_path__ + "img/logo-icon.4598c0e1.png";